export default __webpack_public_path__ + "static/media/ITMangerImg.f15de155.png";